const wsk = {
  page404: {
    title: "Det verkar som att du har gått vilse",
    message: "Har du gått vilse?",
    action_btn: "Tillbaka till start"
  },
  address: {
    title: "Adress",
    type: {
      personal: "Personlig",
      company: "Företag/Organisation"
    },
    organisation: {
      label: "Företagsnamn"
    },
    name: {
      first_name: "Förnamn",
      last_name: "Efternamn",
      label: "Namn"
    },
    contact_person: {
      first_name: "Förnamn",
      last_name: "Efternamn",
      label: "Kontaktperson"
    },
    street: {
      label: "Gata och nummer",
      address1: "Adress",
      address2: "Adress 2"
    },
    city: {
      label: "Stad"
    },
    postal_code: {
      label: "Postnr"
    },
    country_code: {
      label: "Land"
    },
    company_data: {
      title: "Företagsinformation"
    },
    company_id: {
      label: "Organisationsnr (xxxxxx-xxxx)"
    },
    tax_id: {
      label: "Moms-ID"
    },
    vat_id: {
      label: "VAT-nummer"
    }
  },
  empty_state: {
    title: "Här var det tomt..."
  },
  profile: {
    emails: {
      label: "E-postadress (lägg till flera genom att separera med kommatecken)"
    },
    email: {
      label: "E-post"
    },
    phone: {
      label: "Telefon",
      short: "Telefon"
    }
  },
  validation: {
    country_required: "Fyll i land här",
    company_id: {
      not_valid: "Felaktigt organisationsnummer"
    },
    tax_id: {
      not_valid: "Felaktigt momsnummer"
    },
    vat_id: {
      not_valid: "Felaktigt VAT-nummer"
    }
  },
  general: {
    back: "Tillbaka",
    cancel: "Avbryt",
    close: "Stäng",
    remove: "Ta bort",
    optional: "Valfritt",
    period: {
      months_one: "{count} månad",
      years_one: "{count} år",
      months_few: "{count} månader",
      years_few: "{count} år",
      months_other: "{count} månader",
      years_other: "{count} år",
      explicit: "Period",
      short: {
        months: "{ period, plural, one {månad} other {# månader} }",
        years_one: "år",
        years_few: "{count} år",
        years_other: "{count} år"
      },
      next: {
        months_one: "nästa månad",
        years_one: "nästa år",
        months_few: "kommande {count} månader",
        years_few: "kommande {count} år",
        months_other: "kommande {count} månader",
        years_other: "kommande {count} år",
        short: {
          months_one: "nästa månad",
          years_one: "nästa år",
          months_few: "kommande {count}  månader",
          years_few: "kommande {count} år",
          months_other: "kommande {count}  månader",
          years_other: "kommande {count} år"
        }
      },
      per: {
        months_one: "månadsvis",
        years_one: "årsvis",
        months_few: "för {count} månader",
        years_few: "för {count} år",
        months_other: "för {count}  månader",
        years_other: "för {count} år",
        short: {
          months_one: "/månad",
          years_one: "/år",
          months_few: "/{count} månader",
          years_few: "/{count} år",
          months_other: "/{count} månader",
          years_other: "/{count} år"
        }
      }
    },
    or: "eller",
    recommended: "rekommenderas",
    settings: "Inställningar",
    edit: "Redigera",
    save: "Spara",
    save_changes: "Spara ändringar",
    reset_form: "Återställ formulär",
    not_available: "Ej tillgänglig",
    unknown_error: "Okänt fel",
    unknown_error_id: "Okänt fel ({id})",
    something_went_wrong: "Ett oväntat fel uppstod",
    link: "länk",
    buy: "beställ"
  },
  capslock_hint: {
    line1: "Caps lock",
    line2: "är på"
  },
  ws_password_input: {
    expose_password: "Visa lösenord"
  },
  ws_array_input: {
    incorrect_email: "Ogiltig(a) e-postadress(er)",
    incorrect_web: "Ogiltig(a) webbadress(er)",
    some_filtered: "Vissa resultat är inte giltiga."
  },
  ws_places_input: {
    no_results: "Platsen kunde inte hittar, vänligen försök med din postort",
    start_typing: "Börja skriva för att se resultat"
  },
  ws_uploader: {
    validation: {
      file_type: "Filtypen är ej godkänd.",
      file_size: "Filstorleken är över gränsen ({limit})"
    },
    status: {
      label: "Status",
      value: {
        uploaded: "Uppladdat",
        uploading: "uppladdning pågår",
        failed: "misslyckades",
        idle: "inaktiv"
      }
    },
    action: {
      title: "Ladda upp fakturor",
      text1: "Dra och släpp eller",
      link: "välj fil",
      text2: ".",
      abort_tooltip: "Avbryt uppladdning"
    },
    supported_file_types: "Tillåtna format:",
    remove_btn: "Ta bort"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltextsök",
      data_title: "Sök",
      clear_filters: "Rensa alla filter",
      from: "Från",
      to: "Till"
    },
    label: {
      bulk_actions: "Massåtgärder",
      cancel_selection: "Avbryt val",
      item_selected: "valda objekt",
      selected: "Valda",
      filterby: "Filtrera",
      records_per_page: "Antal per sida",
      select_all: "Välj alla"
    }
  },
  ws_password_strength: {
    rule1: "minst 8 tecken",
    rule2: "små och stora bokstäver",
    rule3: "minst en siffra",
    rule4: "minst ett specialtecken"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Lösenorden stämmer inte överens!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "Du kan skicka koden igen om {count} sekund.",
    on_cooldown_few: "Du kan skicka koden igen om {count} sekunder.",
    on_cooldown_other: "Du kan skicka koden igen om {count} sekunder.",
    resend_code: "Skicka kod igen",
    code_being_sent: "Skickar 2FA kod...",
    code_sent_successfully: "2FA kod har skickats",
    error_sending_code: "Det gick inte att skicka 2FA kod",
    invalid_code_pasted: "Ogiltig 2FA-kod klistrades in. Vänligen ange en giltig 2FA-kod."
  },
  generate_random: "Generera nytt",
  copy: {
    copy: "Kopiera",
    copied: "Kopierad",
    saved_in_clipboard: "Sparat i urklipp"
  },
  out_modal: {
    title: "Din webbläsare <br>är ej uppdaterad",
    text: "Du behöver uppgradera till den senaste versionen eller försök med en annan webbläsare",
    delimiter_text: "Vi hjälper till"
  },
  buttons: {
    ok_thanks: "Okej, tack!"
  },
  payment_cards: {
    ending_with: "Slutar med",
    active: "Aktiv",
    issued_by: "This card was issued by {issuer}."
  },
  ws_sub_items_price_summary: {
    current_price: "Pris (nuvarande period)",
    due_now: "Att betala nu",
    next_period_subtraction_warning: "*Priset dras av från nästa faktura",
    next_price: "Pris (nästa period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "Formuläret är tomt"
  },
  price_badge: {
    including_vat: "(inklusive moms)",
    excluding_vat: "(exkl. moms)"
  },
  cart_item: {
    notices: {
      business_mail: {
        license_count_increase: {
          title: "Din domän har redan aktiva brevlådor.",
          text_one: "Du har {count} brevlåda på den här domänen. För att migrera till Business Mail måste du lägga till minst lika många licenser som antalet brevlådor du migrerar.",
          text_few: "Du har {count} brevlådor på den här domänen. För att migrera till Business Mail måste du lägga till minst lika många licenser som antalet brevlådor du migrerar.",
          text_other: "Du har {count} brevlådor på den här domänen. För att migrera till Business Mail måste du lägga till minst lika många licenser som antalet brevlådor du migrerar."
        },
        free_trial: {
          title: "Starta din gratis provperiod idag!",
          text: "Vi aktiverar automatiskt en 60-dagars provperiod för varje Business Mail-tjänst du beställer, så att du kan testa vår Premium-licens helt gratis!"
        },
        free_trial_postfix: {
          title: "Starta din gratis provperiod idag!",
          text_one: "Vi aktiverar automatiskt en 60-dagars provperiod för varje brevlåda som vi migrerar till vår Business Mail-tjänst, så att du kan testa vår Premium-licens helt gratis! Vänligen notera att du måste beställa minst lika många Premium-licenser som antalet brevlådor du migrerar. (Du har 1 brevlåda). <b>Migreringen kan komma att påverka brevlådans innehåll (kontakter/kalendrar), så vi rekommenderar att du läser igenom processen för <a href='https://kunskap.websupport.se/kb/automatiserad-migrering-fran-vanlig-mail-till-business-mail' target='_blank'>hur migreringar till Business Mail fungerar</a> innan du beställer tjänsten.</b>",
          text_few: "Vi aktiverar automatiskt en 60-dagars provperiod för varje brevlåda som vi migrerar till vår Business Mail-tjänst, så att du kan testa vår Premium-licens helt gratis! Vänligen notera att du måste beställa minst lika många Premium-licenser som antalet brevlådor du migrerar. (Du har {count} brevlådor). <b>Migreringen kan komma att påverka brevlådans innehåll (kontakter/kalendrar), så vi rekommenderar att du läser igenom processen för <a href='https://kunskap.websupport.se/kb/automatiserad-migrering-fran-vanlig-mail-till-business-mail' target='_blank'>hur migreringar till Business Mail fungerar</a> innan du beställer tjänsten.</b>",
          text_other: "Vi aktiverar automatiskt en 60-dagars provperiod för varje brevlåda som vi migrerar till vår Business Mail-tjänst, så att du kan testa vår Premium-licens helt gratis! Vänligen notera att du måste beställa minst lika många Premium-licenser som antalet brevlådor du migrerar. (Du har {count} brevlådor). <b>Migreringen kan komma att påverka brevlådans innehåll (kontakter/kalendrar), så vi rekommenderar att du läser igenom processen för <a href='https://kunskap.websupport.se/kb/automatiserad-migrering-fran-vanlig-mail-till-business-mail' target='_blank'>hur migreringar till Business Mail fungerar</a> innan du beställer tjänsten.</b>"
        },
        free_trial_premium_licenses_notice: {
          title_one: "Du behöver minst en Premium licens för att migrera till Business Mail",
          title_few: "Du behöver minst {count} Premium licenser för att migrera till Business Mail",
          title_other: "Du behöver minst {count} Premium licenser för att migrera till Business Mail",
          text: "För att göra det enklare för dig har vi inkluderat de Premium-licenser som krävs, om du ännu inte har gjort det. <b>Notera att migreringen kan påverka innehållet i ditt konto, inklusive kontakter och kalendrar. Därför rekommenderar vi att du tar en titt på hur <a href=https://kunskap.websupport.se/kb/automatiserad-migrering-fran-vanlig-mail-till-business-mail/'>migreringsprocessen för Business Mail</a> fungerar innan du beställer tjänsten.<b>"
        }
      }
    }
  },
  login_pages: {
    footer: {
      help: "Hjälp",
      terms: "Villkor",
      privacy: "Integritet"
    },
    help: {
      title: "Behöver du hjälp?",
      text: "Ta gärna en titt i vår <a href='{kb_url}' target='_blank'>kunskapsdatabas</a> för mer information. Om du inte hittar svaret på din fråga är du varmt välkommen att kontakta vår <a href='{support_url}' target='_blank'>support</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      status_401: {
        text: "You don't have the required permissions."
      },
      status_403: {
        text: "Access denied."
      },
      status_404: {
        title: "Not found.",
        text: "Source not found."
      },
      status_407: {
        text: "Please login via the Legacy Active24 login page."
      },
      status_408: {
        text: "Connection timeout."
      },
      status_500: {
        text: "Uh oh, something went wrong. Please contact our support."
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  },
  ws_input: {
    invalid_phone_number: "Ogiltigt telefonnummer",
    phone_missing: "Telefonnummer krävs"
  },
  ws_google_autocomplete: {
    no_results: "Platsen kunde inte hittar, vänligen försök med din postort"
  }
};
const wsk_svSE = {
  wsk
};
export {
  wsk_svSE as default,
  wsk
};
//# sourceMappingURL=wsk.sv-SE.json.es.js.map
